/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module UploadHsmPackagesPageModule
 */

/* eslint-disable max-classes-per-file */

import {
    Component,
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';

import { L10nService, VIPModule } from '@vmw/ngx-vip';
import { AviCardModule } from 'nsx-alb-ui-components';
import { AviFormsModule } from 'ng/modules/avi-forms/avi-forms.module';
import { SharedModule } from 'ng/shared/shared.module';
import * as l10n from './upload-hsm-packages-page.l10n';
import './upload-hsm-packages-page.component.less';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Upload HSM Packages page component.
 * @author alextsg
 */
@Component({
    selector: 'upload-hsm-packages-page',
    templateUrl: './upload-hsm-packages-page.component.html',
})
export class UploadHsmPackagesPageComponent {
    public readonly l10nKeys = l10nKeys;

    /**
     * Only Thales Safenet HSM is supported.
     */
    public readonly fileApi = 'api/fileservice/hsmpackages?hsmtype=safenet';

    public readonly filePath = 'controller://hsmpackages';

    constructor(l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }
}

@NgModule({
    declarations: [
        UploadHsmPackagesPageComponent,
    ],
    imports: [
        AviFormsModule,
        AviCardModule,
        SharedModule,
        VIPModule.forChild(),
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA,
    ],
})
/* eslint-disable-next-line no-unused-vars */
class UploadHsmPackagesPageModule {}
